import React from 'react';
import { StyledContainer } from './MainContainer.styles';

interface MainContainerProps {
  children?: React.ReactNode;
}

const MainContainer: React.FC<MainContainerProps> = ({ children }) => {
  return <StyledContainer aria-label="main-container">{children}</StyledContainer>;
};

export default MainContainer;
